import { render, staticRenderFns } from "./ChatSetting.vue?vue&type=template&id=08f001fd"
import script from "./ChatSetting.vue?vue&type=script&lang=js"
export * from "./ChatSetting.vue?vue&type=script&lang=js"
import style0 from "./ChatSetting.vue?vue&type=style&index=0&id=08f001fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports